import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BaseSuccessfulAddSnackbar from 'components/BaseSuccessfulAddSnackbar';
import { selectImageUrlForAddedCartItem } from 'bento-ordering/menus/selectors';
import {
  getTotalCartItemQuantities,
  selectIsGroupOrderCurrentDinerAdmin,
  selectCartIsGroupOrder,
  selectCurentDinerAmountSpent
} from 'bento-ordering/cart/selectors';
import { resetLastItem } from 'bento-ordering/cart/actions/lastItem';
import { trackNavigateToCartFromSnackbar } from 'bento-ordering/base/actions/tracking';
import { usePromotionProgressCartUpdateMesssage } from 'bento-ordering/promotions/hooks/usePromotionProgressCartUpdateMesssage';
import ToastPromotionProgress from 'bento-ordering/base/components/ToastPromotionProgress';
import { useHasInvestorDayFeatureFlag } from 'bento-ordering/utils/featureFlags/hasInvestorDayFeatureFlag';

const SuccessfulAddSnackbarV2 = ({
  open,
  item,
  cartQuantity,
  subtotal,
  cartItems,
  addedItemImage,
  dispatch,
  isGroupOrder,
  isGroupOrderAdmin,
  amountSpent
}) => {
  const promotionUpdateMessage = usePromotionProgressCartUpdateMesssage();
  const shouldRenderToastPromotionProgress = !!promotionUpdateMessage;
  const TopMessage = shouldRenderToastPromotionProgress ? (
    <ToastPromotionProgress />
  ) : null;

  const handleSnackbarCloseOnViewCartClick = () => {
    dispatch(resetLastItem());
    trackNavigateToCartFromSnackbar();
  };

  const handleClose = () => {
    dispatch(resetLastItem());
  };

  const shouldShowDinerTotal = isGroupOrder && !isGroupOrderAdmin;
  const hasInvestorDayFeature = useHasInvestorDayFeatureFlag();

  return (
    <BaseSuccessfulAddSnackbar
      open={open}
      item={item}
      cartQuantity={cartQuantity}
      subtotal={shouldShowDinerTotal ? amountSpent : subtotal}
      cartItems={cartItems}
      handleClose={handleClose}
      addedItemImage={addedItemImage}
      handleSnackbarCloseOnViewCartClick={handleSnackbarCloseOnViewCartClick}
      TopMessage={TopMessage}
      hasInvestorDayFeature={hasInvestorDayFeature}
    />
  );
};

SuccessfulAddSnackbarV2.propTypes = {
  item: PropTypes.string.isRequired,
  open: PropTypes.bool,
  cartQuantity: PropTypes.number,
  subtotal: PropTypes.string,
  cartItems: PropTypes.array,
  addedItemImage: PropTypes.object,
  dispatch: PropTypes.func,
  isGroupOrder: PropTypes.bool,
  isGroupOrderAdmin: PropTypes.bool,
  amountSpent: PropTypes.number
};

const mapStateToProps = state => {
  return {
    subtotal: state.cart.subtotal,
    cartQuantity: getTotalCartItemQuantities(state.cart),
    cartItems: state.cart.items,
    addedItemImage: selectImageUrlForAddedCartItem(state),
    isGroupOrder: selectCartIsGroupOrder(state),
    isGroupOrderAdmin: selectIsGroupOrderCurrentDinerAdmin(state),
    amountSpent: selectCurentDinerAmountSpent(state)
  };
};

export default connect(mapStateToProps)(SuccessfulAddSnackbarV2);
